import {
  onBeforeMount,
  onUnmounted,
  ref,
  useStore
} from "@nuxtjs/composition-api";
import { breakpointsTailwind } from "@vueuse/core";
function useBreakpoint(screen) {
  const store = useStore();
  const isBiggerThanBreakpoint = ref(store.getters["device/getIsPc"]);
  const onResize = () => {
    isBiggerThanBreakpoint.value = window.innerWidth >= breakpointsTailwind[screen];
  };
  onBeforeMount(() => {
    onResize();
    window.addEventListener("resize", onResize, { passive: true });
  });
  onUnmounted(() => {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", onResize, {
        passive: true
      });
    }
  });
  return { isBiggerThanBreakpoint };
}
var useBreakpoint_default = useBreakpoint;
export {
  useBreakpoint_default as default
};
